export const Validation = {
	Password: {
		minLength: 8,
	},
};
